import { actions } from "./commonActions";
import { thunks } from "./commonThunks";
import { FirebaseModel, modelFirebase } from "./model-firebase";
import meModel, { ModelMe } from "./model-me";
import modelOpportunities from "./model-opportunities";
import modelActionReports from "./model-action-reports";
import modelFlopptions from "./model-flopptions";
import miscModel, { ModelMisc } from "./model-misc";
import modelDeadOpps from "./model-dead-opps";
import modelDeadFlopptions from "./model-dead-flopptions";
import modelTripNotes from "./model-trip-notes";

// The interface representing our entire store model
export interface StoreModel {
  me: ModelMe;
  firebase: FirebaseModel;
  opportunities: any;
  actionReports: any;
  tripNotes: any;
  flopptions: any;
  misc: ModelMisc;
  dead_flopptions: any;
  dead_opps: any;
}

const model: StoreModel = {
  me: meModel,
  opportunities: modelOpportunities,
  firebase: modelFirebase,
  actionReports: modelActionReports,
  tripNotes: modelTripNotes,
  flopptions: modelFlopptions,
  misc: miscModel,
  dead_flopptions: modelDeadFlopptions,
  dead_opps: modelDeadOpps,
};

function isResourceModel(modelSlice) {
  return !!modelSlice.INITIAL_DATA_ENDPOINT;
}

Object.entries(model).forEach(([modelSliceName, modelSlice]) => {
  if (!isResourceModel(modelSlice)) {
    return;
  }

  modelSlice.initialDataReceived = false;
  modelSlice.initialDataLoading = false;

  const myActions = actions();
  [
    "markInitialDataReceived",
    "markInitialDataNotReceived",
    "markInitialDataLoading",
    "markInitialDataNotLoading",
    "receiveInitialData",
    "clear",
  ].forEach((actionName) => {
    if (!modelSlice[actionName]) {
      modelSlice[actionName] = myActions[actionName];
    }
  });

  const myThunks = thunks(modelSliceName);
  ["handleFetchInitialData", "maybeHandleFetchInitialData"].forEach(
    (thunkName) => {
      if (!modelSlice[thunkName]) {
        modelSlice[thunkName] = myThunks[thunkName];
      }
    }
  );
});

export { model };
